/**
 * Retry policy for the restaurant profile (`/summary`) query, shared by the
 * page's `useQuery` and the route loader's prefetch — whichever starts the
 * fetch fixes its retry behaviour, and the other joins it.
 *
 * A 4xx is a definitive answer (most importantly 404: the restaurant was
 * removed), so retrying only delays the redirect by the backoff (~3s). Network
 * failures and 5xx keep the app-wide default of 2 retries
 * (`makeQueryClient` in `@/lib/queryClient`).
 */

/** Matches the `retry: 2` default in `makeQueryClient`. */
const DEFAULT_MAX_RETRIES = 2;

/** True for an axios-style error whose response status is a 4xx. */
export function isClientError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
}

export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  if (isClientError(error)) return false;
  return failureCount < DEFAULT_MAX_RETRIES;
}
